<div class="messages-tab-container">
  <ngx-spinner [name]="spinnerName" type="ball-atom"></ngx-spinner>

  <div class="messages-header">
    <div class="header-left">
      <mat-button-toggle-group [value]="activeMailbox" (change)="onMailboxChange($event.value)" hideSingleSelectionIndicator>
        <mat-button-toggle value="inbox">Inbox</mat-button-toggle>
        <mat-button-toggle value="sent">Sent</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="button-group">
      @if (!isReadOnly()) {
        <button mat-raised-button color="primary" (click)="onComposeMessage()">
          <mat-icon>edit</mat-icon>
          Compose
        </button>
      }
    </div>
  </div>

  @if (dataSource.data.length > 0) {
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)" class="mat-elevation-z2">

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
        <td mat-cell *matCellDef="let message" [class.unread]="!message.isRead && activeMailbox === 'inbox'" [class.selected-row-cell]="selectedMessage?.id === message.id || (message.isAnswer && selectedMessage?.id === message.parentMessageId)">
          @if (activeMailbox === 'sent') {
            <mat-icon class="mail-icon">send</mat-icon>
          } @else if (message.isAnswer) {
            <mat-icon class="reply-icon">reply</mat-icon>
          } @else {
            <mat-icon class="mail-icon">{{ message.isRead ? 'drafts' : 'mark_email_unread' }}</mat-icon>
          }
          @if (message.title) { {{ message.title }} } @else { <em>(Untitled)</em> }
        </td>
      </ng-container>

      <ng-container matColumnDef="sentByUserFullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
        <td mat-cell *matCellDef="let message" [class.unread]="!message.isRead && activeMailbox === 'inbox'" [class.selected-row-cell]="selectedMessage?.id === message.id || (message.isAnswer && selectedMessage?.id === message.parentMessageId)">{{ message.sentByUserFullName }}</td>
      </ng-container>

      <ng-container matColumnDef="recipients">
        <th mat-header-cell *matHeaderCellDef>To</th>
        <td mat-cell *matCellDef="let message" [class.selected-row-cell]="selectedMessage?.id === message.id || (message.isAnswer && selectedMessage?.id === message.parentMessageId)">{{ getRecipientNames(message) }}</td>
      </ng-container>

      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let message" [class.unread]="!message.isRead && activeMailbox === 'inbox'" [class.selected-row-cell]="selectedMessage?.id === message.id || (message.isAnswer && selectedMessage?.id === message.parentMessageId)">{{ message.createdDate | date:'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let message" class="actions-cell" [class.selected-row-cell]="selectedMessage?.id === message.id || (message.isAnswer && selectedMessage?.id === message.parentMessageId)">
          <div class="action-buttons">
            <button mat-icon-button
                    class="attachment-button"
                    [class.has-attachment]="message.hasAttachment"
                    [matTooltip]="message.hasAttachment ? 'Has attachment' : ''"
                    [disabled]="!message.hasAttachment">
              <mat-icon>attach_file</mat-icon>
            </button>
            @if (activeMailbox === 'inbox') {
              <button mat-icon-button
                      class="read-button"
                      [matTooltip]="message.isRead ? 'Mark as unread' : 'Mark as read'"
                      (click)="onToggleReadStatus(message, $event)">
                <mat-icon>{{ message.isRead ? 'drafts' : 'mark_email_unread' }}</mat-icon>
              </button>
            }
            @if (!message.isAnswer && !isReadOnly()) {
              <button mat-icon-button
                      class="delete-button"
                      matTooltip="Delete"
                      (click)="onDeleteClick(message, $event)">
                <mat-icon>delete</mat-icon>
              </button>
            } @else {
              <span class="icon-placeholder"></span>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable-row" (click)="onRowClick(row)"></tr>
    </table>
    <mat-paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 20]"
      [showFirstLastButtons]="true"
      (page)="onPageChange($event)">
    </mat-paginator>
  } @else {
    <div class="empty-state">
      No messages found for this company.
    </div>
  }

  <!-- Inline message view -->
  @if (selectedMessage) {
    <div class="inline-message-view">
      <ngx-spinner [name]="viewSpinnerName" type="ball-atom"></ngx-spinner>

      <div class="message-view-header">
        <div class="message-view-title">
          <h3>@if (selectedMessage.title) { {{ selectedMessage.title }} } @else { <em>(Untitled)</em> }</h3>
          <span class="message-view-from">from {{ selectedMessage.sentByUserFullName }} to {{ getSelectedRecipientNames() }}</span>
        </div>
        <div class="button-group">
          @if (selectedMessage.hasAttachment) {
            <button mat-raised-button color="primary" (click)="onDownloadAttachment()">
              <mat-icon>download</mat-icon>
              {{ selectedMessage.fileName || 'Download' }}
            </button>
          }
          <button mat-icon-button matTooltip="Close" (click)="closeMessageView()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="conversation-thread">
        <!-- Original Message -->
        <div class="message-card original-message">
          <div class="message-header">
            <div class="message-sender">
              <div class="avatar">
                <mat-icon>person</mat-icon>
              </div>
              <div class="sender-info">
                <span class="sender-name">{{ selectedMessage.sentByUserFullName }}</span>
                <span class="message-meta">to {{ getSelectedRecipientNames() }}</span>
              </div>
            </div>
            <span class="message-date">{{ selectedMessage.createdDate | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <div class="message-body" [innerHTML]="selectedMessage.messageText | linkify"></div>
        </div>

        <!-- Replies -->
        @for (answer of visibleAnswers; track answer.id) {
          <div class="message-card reply-message" [style.border-left-color]="'color-mix(in srgb, var(--mat-sys-primary) ' + (100 - $index * 15) + '%, transparent)'">
            <div class="message-header">
              <div class="message-sender">
                <div class="avatar">
                  <mat-icon>person</mat-icon>
                </div>
                <div class="sender-info">
                  <span class="sender-name">{{ answer.sentByUserFullName }}</span>
                  <span class="message-meta">to {{ getAnswerRecipientNames(answer) }}</span>
                </div>
              </div>
              <span class="message-date">{{ answer.createdDate | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <div class="message-body" [innerHTML]="answer.answerText | linkify"></div>
          </div>
        }

        @if (hasHiddenAnswers) {
          <div class="show-full-thread">
            <button mat-raised-button color="primary" (click)="onShowFullConversation()">
              <mat-icon>unfold_more</mat-icon>
              Show full conversation
            </button>
          </div>
        }

        <!-- Reply Box -->
        @if (!isReadOnly()) {
        <div class="reply-section">
          @if (!isReplying) {
            <button mat-raised-button color="primary" (click)="onToggleReply()">
              <mat-icon>reply</mat-icon>
              Reply
            </button>
          } @else {
            <div class="message-card reply-compose">
              <form [formGroup]="replyForm">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Write your reply...</mat-label>
                  <textarea matInput formControlName="answerText" rows="4"></textarea>
                  @if (replyForm.get('answerText')?.hasError('required') && replyForm.get('answerText')?.touched) {
                    <mat-error>Reply cannot be empty</mat-error>
                  }
                </mat-form-field>
              </form>
              <div class="reply-actions">
                <button mat-flat-button class="nrg-error-flat-button" (click)="onToggleReply()">
                  <mat-icon>clear</mat-icon>
                  Cancel
                </button>
                <button mat-flat-button color="primary" (click)="onSendReply()" [disabled]="replyForm.invalid">
                  <mat-icon>send</mat-icon>
                  Send
                </button>
              </div>
            </div>
          }
        </div>
        }
      </div>
    </div>
  }
</div>
